import { useQuery } from '@tanstack/react-query'
import { searchApi } from '@/services/search'
import { useDebounce } from '@/hooks/useDebounce'

// Minimum characters before a search request is fired (matches the backend's
// `min:2` rule on `q`).
export const SEARCH_MIN_CHARS = 2

// Debounced global search. Returns React Query state for the grouped results;
// the query is disabled until the (debounced) term reaches the min length.
export function useGlobalSearch(term: string) {
  const debounced = useDebounce(term.trim(), 300)
  const enabled = debounced.length >= SEARCH_MIN_CHARS

  const query = useQuery({
    queryKey: ['global-search', debounced],
    queryFn: () => searchApi.global(debounced),
    enabled,
    staleTime: 30_000,
  })

  return { ...query, debounced, enabled }
}
